import { SvgIconProps } from "@mui/material/SvgIcon";
import clsx from "clsx";
import React, { FC } from "react";
export type RHArrowIconProps = SvgIconProps & {
  strokeColor?: string;
  strokeWidth?: number;
};

export const RHArrowIcon: FC<RHArrowIconProps> = ({
  strokeColor = "black",
  strokeWidth = 0.75,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      id="test-rh-arrow-icon"
      {...props}
      className={clsx("inline-block !h-4 !w-4 text-base", props.className)}
    >
      <path
        d="M6 4L10 8L6 12"
        stroke={strokeColor}
        stroke-width={strokeWidth}
      />
    </svg>
  );
};

export default RHArrowIcon;
